/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JusoVo } from './JusoVo';
import {
    JusoVoFromJSON,
    JusoVoFromJSONTyped,
    JusoVoToJSON,
    JusoVoToJSONTyped,
} from './JusoVo';

/**
 * 
 * @export
 * @interface KrAddressResultVo
 */
export interface KrAddressResultVo {
    /**
     * 第三方错误信息
     * @type {string}
     * @memberof KrAddressResultVo
     */
    errorMessage?: string;
    /**
     * 第三方错误码 0 是成功，非0 是失败
     * @type {string}
     * @memberof KrAddressResultVo
     */
    errorCode?: string;
    /**
     * 地址列表
     * @type {Array<JusoVo>}
     * @memberof KrAddressResultVo
     */
    juso?: Array<JusoVo>;
}

/**
 * Check if a given object implements the KrAddressResultVo interface.
 */
export function instanceOfKrAddressResultVo(value: object): value is KrAddressResultVo {
    return true;
}

export function KrAddressResultVoFromJSON(json: any): KrAddressResultVo {
    return KrAddressResultVoFromJSONTyped(json, false);
}

export function KrAddressResultVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KrAddressResultVo {
    if (json == null) {
        return json;
    }
    return {
        
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'juso': json['juso'] == null ? undefined : ((json['juso'] as Array<any>).map(JusoVoFromJSON)),
    };
}

export function KrAddressResultVoToJSON(json: any): KrAddressResultVo {
    return KrAddressResultVoToJSONTyped(json, false);
}

export function KrAddressResultVoToJSONTyped(value?: KrAddressResultVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'errorMessage': value['errorMessage'],
        'errorCode': value['errorCode'],
        'juso': value['juso'] == null ? undefined : ((value['juso'] as Array<any>).map(JusoVoToJSON)),
    };
}

